import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useBiLogModalPageView } from '@wix/da-shared-react/pkg/biLogger/hooks/useBiLogModalPageView';
import DeviationDropZoneWrapper from '../DeviationDropZoneWrapper';
import DeviationFormPopup from '../DeviationFormPopup';
import OriginalsDeliveryFormPopup from '../OriginalsDeliveryFormPopup';
import { splashReady } from '../../redux/actions';

export interface Props {
  deviationId?: number;
  originalsDeviationId?: number;
  originalsResponseId?: number;
  tierId?: number;
  isDraft?: boolean;
  isEdit?: boolean;
  isPageLoadModal?: boolean;
  requestClose: () => void;
}

export const DeviationSubmitPopup: React.FC<Props> = ({
  deviationId: initialDeviationId,
  originalsDeviationId,
  originalsResponseId,
  tierId,
  isDraft,
  isEdit,
  isPageLoadModal,
  requestClose,
}) => {
  const dispatch = useDispatch();
  const [deviationId, setDeviationId] = useState(initialDeviationId);
  const { logPageView } = useBiLogModalPageView({
    component: initialDeviationId
      ? 'form-edit'
      : tierId
        ? 'upload-tier'
        : 'upload-deviation',
    view: 'submit',
  });

  const isOriginalsDelivery = originalsDeviationId && originalsResponseId;

  // If deviationId changes it means we got an upload and are moving to form step, so we fire another page view event
  useEffect(() => {
    if (deviationId !== initialDeviationId) {
      logPageView({
        component: tierId ? 'form-tier' : 'form-deviation',
        view: 'submit',
      });
    }
  }, [initialDeviationId, deviationId, tierId, logPageView]);

  useEffect(() => {
    if (!deviationId) {
      dispatch(splashReady());
    }
  }, [deviationId, dispatch]);

  return (
    <>
      {!deviationId && (
        <DeviationDropZoneWrapper
          originalsDeviationId={originalsDeviationId}
          originalsResponseId={originalsResponseId}
          requestClose={requestClose}
          tierId={tierId}
          isPageLoadModal={isPageLoadModal}
          onDeviationCreated={setDeviationId}
        />
      )}
      {deviationId && !isOriginalsDelivery && (
        <DeviationFormPopup
          requestClose={requestClose}
          params={{
            deviationId,
            tierId,
            isDraft,
            isEdit,
          }}
        />
      )}
      {deviationId && isOriginalsDelivery && (
        <OriginalsDeliveryFormPopup
          requestClose={requestClose}
          params={{
            deviationId,
            originalsDeviationId,
            originalsResponseId,
          }}
        />
      )}
    </>
  );
};
DeviationSubmitPopup.displayName = 'DeviationSubmitPopup';

export default DeviationSubmitPopup;
